<template>
  <main
    class="main internet_main bg_gr"
    role="main"
    ref="main"
    v-show="isCompleted"
  >
    <div class="home internet">
      <div class="sect main_sevice_top">
        <div class="sevice_ani">
          <Lottie :options="options" @animCreated="handleAnimation" />
        </div>
        <div class="txt">
          <p>손쉽게 원하는 조건을 입력하고</p>
          <h2>인터넷 견적을 받아보세요!</h2>
        </div>
        <div class="btn_top">
          <button @click="goLink('InternetCommerce.Create')">
            바로 견적 요청하기
          </button>
        </div>
      </div>

      <InternetProducts
        ref="InternetProducts"
        :list="internetProductList"
        :total="internetProductTotal"
        :filter="internetFilter"
        :params="internetProductParams"
        :ktPromotionView="ktPromotionView"
        :helloPromotionView="helloPromotionView"
        :centerBnr="centerBnr"
        @fetch="internetProductFilter"
        @filter="openInternetFilter"
        @reset="resetInternetFilter"
        @more="internetViewMore"
        @view="goInternetView"
        @goPromotionDetail="goPromotionDetail"
      />
    </div>
    <InternetFilter
      ref="internetFilter"
      :show="isInternetFilter"
      :filterSelTab="internetFilterSelTab"
      @close="closeInternetFilter"
    />
    <DesignPopup2
      :show="designPopup"
      :data="{
        title: '동네 설정 안내',
        type: 'alert',
        msg: `동네 설정이 안되어 있습니다.<br />원활한 서비스를 위해 동네 설정 페이지로 이동합니다.`,
      }"
      @close="popupClose"
    />
  </main>
</template>
<script>
import * as util from '@common/lib/common/utils.js';

import promotionCfg from '@common/lib/common/promotionCfg';

import format from 'date-fns/format';

import Lottie from 'vue-lottie/src/lottie';
import * as animationData from '@/assets/front/animation/ani_home_internet.json';

import InternetProducts from '@/front/customer/views/home/components/InternetProducts';

import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import { mapActions as bannerMapActions } from '@common/store/modules/banner';
import * as bannerTypes from '@common/store/modules/banner/types';

import InternetFilter from '@/common/components/modal/InternetFilter';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';

export default {
  name: 'InternetMain',
  components: {
    Lottie,
    InternetFilter,
    InternetProducts,
    DesignPopup2,
  },

  data() {
    return {
      options: { animationData: animationData.default },
      // animationSpeed: 1,
      scrollLocation: 0,
      isCompleted: false,

      selCoverage: 'Y',
      selBookmark: 'N',

      isInternetFilter: false,
      internetFilterSelTab: '',
      internetProductParams: {
        page: 1,
        size: 5,
        orderType: 'PRICE_ASC', // PRICE_DESC, PRICE_ASC
        selTv: 'Y', // TV 선택 여부
        selCoverage: 'Y', // 우리동네 설치 가능만
        selBookmark: 'N', // 찜하기
        sido: '', // 시도
        sigungu: '', // 시군구
      },
      internetFilter: {
        item: ['internetNtv'],
        speed: ['ALL'],
        telecom: ['ALL'],
        price: ['ALL'],
      },
      internetProductList: [],
      internetProductTotal: 0,
      isInternetBack: false,

      isVisitName: [
        'Search',
        'MyPage.Main',
        'InternetCommerce.Create',
        'InternetCommerce.List',
        'InternetCommerce.ItemView',
      ], // 뒤로 이동시 가능한 방문 페이지 정리

      isSortModal: false,
      selectedSort: { label: '낮은 가격 순', value: 'PRICE_ASC' },
      designPopup: false,
      ktPromotionView: false,
      helloPromotionView: false,
      centerBnr: [
        {
          telecom: 'HELLO',
          linkName: 'InternetCommerce.PromotionDetailHello',
          params: {},
          img: 'img_promotion_bnr_hello.png',
        },
        {
          telecom: 'KT',
          linkName: 'InternetCommerce.PromotionDetailKt',
          params: { type: '100M' },
          img: 'img_promotion_bnr_kt.png',
        },
      ],
    };
  },
  async created() {
    if (util.isApp()) {
      util.nativeEnableBackKey(); // 앱 백키 허용
    }
    await this.fetchMe(); // 나의 정보

    await this.getInternetProducts(); // 나에게 맞는 인터넷

    await this.fetchPromotionView(); // 프로모션 배너 노출

    util.sleep(300);

    this.isCompleted = true;

    await this.setBnr();

    await util.nativeNotification(); // 앱 알림 권한 확인

    await this.setPromotionBnrView('INTERNET_MAIN_CENTER', 'VIEW'); // 노출 확인
  },
  async mounted() {},
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...internetMapGetters({
      internetCommerceIngList: internetTypes.INTERNET_COMMERCE_ING_LIST,
      internetCommerceEndList: internetTypes.INTERNET_COMMERCE_END_LIST,
      internetCommercUserQuotationNewList:
        internetTypes.INTERNET_COMMERCE_USER_QUOTATION_NEW,
    }),
  },
  methods: {
    ...bannerMapActions([bannerTypes.CLICK_VIEW_BANNER]),
    ...userMapActions([userTypes.FETCH_ME]),
    ...internetMapActions([
      internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION,
      internetTypes.SELECT_INTERNET_COMMERCE_USER_QUOTATION_NEW,
      internetTypes.SELECT_INTERNET_PRODUCTS,
      internetTypes.UPDATE_INTERNET_VIEW_PRODUCT,
    ]),
    handleAnimation: function(anim) {
      this.anim = anim;
    },
    goLink(link) {
      this.$router.push({ name: link });
    },
    async fetchMe() {
      await this[userTypes.FETCH_ME]();
      if (this.user.emdAreaName == null || this.user.emdAreaName == '') {
        this.designPopup = true;
      }
      console.log('this.userthis.userthis.user');
      console.log(this.user);
    },
    popupClose() {
      this.designPopup = false;

      this.$router.push({
        name: 'Auth.Region',
        query: { from: 'Main' },
      });
    },
    openInternetFilter(selTab) {
      this.isInternetFilter = true;
      this.internetFilterSelTab = selTab;
      document.body.style.overflow = 'hidden';
    },
    closeInternetFilter(dataType, item, speed, telecom, price) {
      if (dataType) {
        console.log('dataType =' + dataType);
        console.log('item =' + item);
        console.log('speed =' + speed);
        console.log('telecom =' + telecom);
        console.log('price =' + price);

        if (item == 'internetNtv') {
          this.internetProductParams.selTv = 'Y';
        } else if (item == 'internet') {
          this.internetProductParams.selTv = 'N';
        }
        this.internetFilter.item = item;
        this.internetFilter.speed = speed;
        this.internetFilter.telecom = telecom;
        this.internetFilter.price = price;
        this.internetProductInit();
        this.getInternetProducts();
      }
      this.isInternetFilter = false;
      document.body.style.overflow = '';
    },
    async resetInternetFilter() {
      this.internetProductParams.orderType = 'PRICE_ASC';
      this.internetProductParams.selTv = 'Y';
      this.internetProductParams.selCoverage = 'Y';
      this.internetProductParams.selBookmark = 'N';
      this.internetFilter = {
        item: ['internetNtv'],
        speed: ['ALL'],
        telecom: ['ALL'],
        price: ['ALL'],
      };
      await this.internetProductInit();

      this.getInternetProducts();
    },
    async internetProductInit() {
      this.isInternetBack = false;
      this.internetProductParams.page = 1;
      this.internetProductParams.size = 5;
      this.internetProductList = [];
    },
    async getInternetProducts() {
      if (!this.isInternetBack) {
        console.log('this.internetProductParams');
        console.log(this.internetProductParams);
        // 사용자 주소
        if (this.user.emdAreaName != null) {
          const area = this.user.emdAreaName.split(' ');
          this.internetProductParams.sido = area[0];
          this.internetProductParams.sigungu = area[1];
        }

        // 인터넷 필터 string으로 변환
        this.internetProductParams.internetSpeeds = this.internetFilter.speed.join(
          ',',
        );
        this.internetProductParams.telecoms = this.internetFilter.telecom.join(
          ',',
        );
        this.internetProductParams.prices = this.internetFilter.price.join(',');
      }
      await this[internetTypes.SELECT_INTERNET_PRODUCTS](
        this.internetProductParams,
      ).then(res => {
        if (res.content) {
          this.internetProductList = this.internetProductList.concat(
            res.content,
          );
        }
        this.internetProductTotal = res.totalCount;
        console.log('internetProductList');
        console.log(this.internetProductList);
      });
    },
    goInternetView(item) {
      // 상품 조회 카운트 증가
      this.upInternetViewProductCnt(item);
      localStorage.setItem('internetProductSelect', JSON.stringify(item));
      this.$router.push({
        name: 'InternetCommerce.ItemView',
      });
    },
    upInternetViewProductCnt(item) {
      const params = {
        telecomId: item.telecomId,
        internetId: item.internetId,
        settopId: item.settopId,
        tvId: item.tvId,
        wifiId: item.wifiId,
      };
      console.log('params');
      console.log(params);
      this[internetTypes.UPDATE_INTERNET_VIEW_PRODUCT](params);
    },
    internetProductFilter(type, val) {
      this.internetProductInit();
      this.internetProductParams[type] = val;
      this.getInternetProducts();
    },
    internetViewMore() {
      this.internetPageSet();
      this.internetProductParams.page++;
      this.getInternetProducts();
    },
    internetPageSet() {
      if (
        this.internetProductParams.size > 5 &&
        this.internetProductParams.page == 1
      ) {
        this.internetProductParams.page = this.internetProductParams.size / 5;
        this.internetProductParams.size = 5;
      }
    },
    async fetchPromotionView() {
      if (this.user.emdAreaName == null || this.user.emdAreaName == '') {
        console.log(1);
      } else {
        let areaArr = this.user.emdAreaName.split(' ');
        let areaSido = areaArr[0];
        let areaSigungu = areaArr[1];
        console.log('fetchPromotionView');
        console.log(areaArr);
        console.log(areaSido);
        console.log(areaSigungu);
        this.ktPromotionView = promotionCfg.getSidoCheck('KT', areaSido);

        let sidoCheck = promotionCfg.getSidoCheck('HELLO', areaSido);
        if (sidoCheck) {
          this.helloPromotionView = promotionCfg.getSigungu(
            'HELLO',
            areaSido,
            areaSigungu,
          );
        } else {
          this.helloPromotionView = false;
        }
      }
    },
    goPromotionDetail(linkName, params) {
      if (linkName == 'InternetCommerce.PromotionDetailKt') {
        util.sdk_logEvent('INTERNET_PROMOTION_BANNER', {
          promotionCode: 'KT2408',
          user_id: this.user.id,
          user_nickname: this.user.nickname,
          telecom: 'KT',
          banner_position: 'INTERNET_MAIN_CENTER',
        });

        util.sdk_logEventKakao(
          'INTERNET_PROMOTION_BANNER_INTERNET_MAIN_CENTER',
        );

        this.setPromotionBnrView('INTERNET_MAIN_CENTER', 'CLICK', 'KT');
      } else if (linkName == 'InternetCommerce.PromotionDetailHello') {
        util.sdk_logEvent('INTERNET_PROMOTION_BANNER', {
          promotionCode: 'HELLO',
          user_id: this.user.id,
          user_nickname: this.user.nickname,
          telecom: 'HELLO',
          banner_position: 'INTERNET_MAIN_CENTER',
        });

        util.sdk_logEventKakao(
          'INTERNET_PROMOTION_BANNER_INTERNET_MAIN_CENTER',
        );

        this.setPromotionBnrView('INTERNET_MAIN_CENTER', 'CLICK', 'HELLO');
      }
      this.$router.push({
        name: linkName,
        params: params,
      });
    },
    setPromotionBnrView(place, type, telecom = '') {
      if (this.ktPromotionView && (telecom == '' || telecom == 'KT')) {
        // 노출 이벤트
        const params = {
          company: 'KT',
          campaign: 'PROMOTION',
          place: place,
          type: type,
        };
        this[bannerTypes.CLICK_VIEW_BANNER](params);
      }

      if (this.helloPromotionView && (telecom == '' || telecom == 'HELLO')) {
        // 노출 이벤트
        const params = {
          company: 'HELLO',
          campaign: 'PROMOTION_1',
          place: place,
          type: type,
        };
        this[bannerTypes.CLICK_VIEW_BANNER](params);
      }
    },
    async setBnr() {
      let centerBnrLeng = this.centerBnr.length;

      if (!this.ktPromotionView) {
        // 메인 중간 배너 셋팅
        let index = 0;
        for (let i = 0; i < centerBnrLeng; i++) {
          console.log(i);
          if (this.centerBnr[i].telecom == 'KT') {
            index = i;
            break;
          }
        }
        this.centerBnr.splice(index, 1);
      }

      if (!this.helloPromotionView) {
        // 메인 중간 배너 셋팅
        let index = 0;
        for (let i = 0; i < centerBnrLeng; i++) {
          console.log(i);
          if (this.centerBnr[i].telecom == 'HELLO') {
            index = i;
            break;
          }
        }
        this.centerBnr.splice(index, 1);
      }
    },
  },
};
</script>
